import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BgBox from "../../../common/BgBox";
import CardUI from "../../../common/Card";
import MccLogo from "../../../components/MccLogo";
import {
  Box,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HeaderText from "../../../common/HeaderText";
import { LoadingButton } from "@mui/lab";
import PracticeTermsContent from "../../../components/PracticeTermsContent";

const TermsOfService = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const agentData = state && state.agentData;

  const [checkedTos, setCheckedTos] = useState(false);
  const [openTermsModal, setOpenTermsModal] = useState(false);

  useEffect(() => {
    if (state === null) {
      navigate(-1);
      return;
    }
  }, []);

  if (state === null) {
    navigate(-1);
    return;
  }

  const navigateWorkSpaceHandler = (e) => {
    e.preventDefault();
    if (!checkedTos) {
      return;
    }

    navigate("/create-workspace", {
      replace: true,
      state: { termsOfService: true, agentData: agentData },
    });
  };

  return (
    <BgBox>
      <CardUI>
        {/* MCC LOGO */}
        <MccLogo />

        <Grid container component="main">
          <Box
            component="form"
            onSubmit={navigateWorkSpaceHandler}
            xs={12}
            display="flex"
            gap="16px"
            flexDirection="column"
            width="100%"
          >
            <Box>
              <HeaderText
                variant="h3"
                fontSize={48}
                textContent="Terms of service"
              />
              <Typography variant="body1" fontSize={16} mt="16px">
                Please read and agree to the terms of service to continue.{" "}
              </Typography>

              <Typography variant="body1" fontSize={16} mt="16px">
                <Box
                  component="span"
                  color="#0C80F3"
                  onClick={() => setOpenTermsModal(true)}
                  sx={{ cursor: "pointer", textDecoration: "underline" }}
                >
                  {" "}
                  Click here
                </Box>{" "}
                to read the terms of service{" "}
              </Typography>

              <Box my="16px">
                <FormControlLabel
                  control={
                    <Checkbox
                      value={checkedTos}
                      onChange={(e) => setCheckedTos(e.target.checked)}
                    />
                  }
                  label="I have read and agree to the Terms of Service"
                />
              </Box>
            </Box>

            <LoadingButton
              fullWidth
              type="submit"
              variant="contained"
              disabled={!checkedTos}
              sx={{ padding: "8px 22px", fontSize: 15 }}
            >
              Continue
            </LoadingButton>
          </Box>
        </Grid>
      </CardUI>

      <Dialog
        open={openTermsModal}
        onClose={() => setOpenTermsModal(false)}
        maxWidth="md"
        fullWidth
        scroll="paper"
        PaperProps={{
          sx: {
            maxWidth: "700px",
            maxHeight: "85vh",
            borderRadius: "8px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            pr: 1,
            borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
          }}
        >
          <Typography
            variant="h6"
            fontWeight={600}
            color="#212121"
            sx={{ fontSize: { xs: 22, sm: 26 } }}
          >
            BIOSYNC IQ PRACTICE TERMS AND CONDITIONS
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => setOpenTermsModal(false)}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ px: { xs: 2, sm: 3 }, py: 3 }}>
          <PracticeTermsContent compact />
        </DialogContent>
      </Dialog>
    </BgBox>
  );
};

export default TermsOfService;
